export const NAVIGATE = "NAVIGATE";